<template>
  <div class="dynamic-content-card-wrapper">
    <div class="dynamic-content-card" :style="cardStyle">
      <h2 v-if="title" class="dynamic-content-card__title" :style="{ color: fontColor }">{{ title }}</h2>
      <p v-if="description" class="dynamic-content-card__description" :style="{ color: fontColor }">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicContentCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#f5f5f5'
    },
    fontColor: {
      type: String,
      default: '#000000'
    }
  },
  computed: {
    cardStyle() {
      return {
        'background-color': this.backgroundColor,
        color: this.fontColor
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-content-card-wrapper {
  padding: 0 24px;
}

.dynamic-content-card {
  padding: 32px 24px;
  max-width: 500px;
  margin: 24px auto;
  border-radius: 8px;
  text-align: center;

  &__title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 12px;
  }

  &__description {
    font-size: 1rem;
    line-height: 1.6;
    opacity: 0.9;
  }
}
</style>
